import { QUERY_GET_CONTRACT, QUERY_GET_CONTRACT_BY_CASE_ID,QUERY_GET_COMMENTS_CASE_BY_ID,QUERY_PUT_UPDATECASE, QUERY_PUT_UPDATE_CONTRACT_DATA, QUERY_POST_CREATECASE,QUERY_GET_NEWCASE, QUERY_GET_CUSTOMER_CONTRACT_DATA, QUERY_POST_LOGIN, QUERY_PUT_ASSOCIATE_CONTRACT, QUERY_GET_CONTRACT_SIMPLE, QUERY_PUT_ATTACH_IDT_PROCESS_TO_CASE, QUERY_GET_CONTRACT_LIST, QUERY_PUT_UPDATE_CONTRACT, QUERY_PUT_UPDATE_CUSTOMER_ADITIONAL_INFO } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getContract = baseThunk("contract/GetContract", QUERY_GET_CONTRACT, "GET")

export const getContractSimple = baseThunk("contract/GetContractSimple", QUERY_GET_CONTRACT_SIMPLE, "GET")

export const associateContract = baseThunk('contract/associateContract', QUERY_PUT_ASSOCIATE_CONTRACT, "PUT")

export const getContractByCaseId = baseThunk('contract/GetContractByCaseId', QUERY_GET_CONTRACT_BY_CASE_ID, "GET")

export const updateCase = baseThunk('case/updateCase', QUERY_PUT_UPDATECASE, "PUT");

export const createCase = baseThunk("case/create",QUERY_POST_CREATECASE, "POST");

export const getCommentByCaseId = baseThunk("cases/GetCommentsByCaseId",QUERY_GET_COMMENTS_CASE_BY_ID,"GET")

export const newCase = baseThunk('case/newCase', QUERY_GET_NEWCASE, "GET");

export const updateContractData = baseThunk('contract/updateContractData', QUERY_PUT_UPDATE_CONTRACT_DATA, "PUT")

export const getCustomerContractData = baseThunk('contract/GetCustomerContractData', QUERY_GET_CUSTOMER_CONTRACT_DATA, "GET")

export const attachIdtProcessToCase = baseThunk('contract/attachIdtProcessToCase', QUERY_PUT_ATTACH_IDT_PROCESS_TO_CASE, "PUT")

export const getContractList = baseThunk('contract/getContractList', QUERY_GET_CONTRACT_LIST, "GET");

export const updateContract = baseThunk('contract/updateContract', QUERY_PUT_UPDATE_CONTRACT, "PUT")


// LINKED TO CUSTOMER DATA
export const updateCustomerData = baseThunk('customers/updateAditionalInfo', QUERY_PUT_UPDATE_CUSTOMER_ADITIONAL_INFO, "PUT")